import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { useState } from "react";
import { SegmentedTabs } from "@/components/ui/segmented-tabs";
import { PersonasPanel } from "./PersonasPanel";
import { PromptsPanel } from "./PromptsPanel";
import { ScreeningPanel } from "./ScreeningPanel";
import { AlertNotificationsPanel } from "./AlertNotificationsPanel";

const SETTINGS_TABS = [
  { id: "alerts", label: "Alerts" },
  { id: "personas", label: "Models" },
  { id: "prompts", label: "Prompts" },
];

export interface SettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  initialTab?: string;
}

/** Right slide-over for Guardians v2 configuration. */
export function SettingsDrawer({ open, onClose, initialTab = "alerts" }: SettingsDrawerProps) {
  const [tab, setTab] = useState(initialTab);

  if (!open) return null;

  return (
    <>
      <button
        type="button"
        className="fixed inset-0 z-40 bg-black/40"
        aria-label="Close settings"
        onClick={onClose}
        data-testid="settings-drawer-backdrop"
      />
      <aside
        className={`fixed right-0 top-0 z-50 flex h-full flex-col rounded-l-2xl bg-slate-700 shadow-xl ${
          tab === "prompts" ? "w-[min(720px,92vw)]" : "w-[480px]"
        }`}
        data-testid="settings-drawer"
      >
        <header className="flex items-center justify-between border-b border-white/5 p-4">
          <h2 className="text-lg font-semibold text-slate-100">Settings</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-400 hover:bg-white/5"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>
        <div className="border-b border-white/5 px-4">
          <SegmentedTabs tabs={SETTINGS_TABS} activeId={tab} onChange={setTab} />
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {tab === "alerts" ? (
            <div className="space-y-8">
              <ScreeningPanel />
              <AlertNotificationsPanel />
            </div>
          ) : null}
          {tab === "personas" ? <PersonasPanel /> : null}
          {tab === "prompts" ? <PromptsPanel /> : null}
        </div>
      </aside>
    </>
  );
}
